import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Stack} from 'shells/layout/stack/stack';
import {LoadingText} from 'shells/loading-placeholder/loading-text';

export function AiResponseLoadingState() {
    return (
        <Stack spacing={8}>
            <LoadingText
                height={30}
                isFullWidth={true}
                isRounded={true}
                opacity={0.8}
                color={colors.plumLt}
            />
            <LoadingText
                height={30}
                isFullWidth={true}
                isRounded={true}
                opacity={0.58}
                color={colors.plumLt}
            />
            <LoadingText
                height={30}
                isFullWidth={true}
                isRounded={true}
                opacity={0.35}
                color={colors.plumLt}
            />
        </Stack>
    );
}
